// SellerDeliveries.jsx
import React, { useState, useEffect } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { baseUrl } from "../Univ";

function SellerDeliveries() {
  const [deliveries, setDeliveries] = useState([]);
  const [drivers, setDrivers] = useState([]);
  const [selectedDriver, setSelectedDriver] = useState({}); // {deliveryId: driverId}

  const fetchDeliveries = () => {
    axios
      .get(baseUrl + "seller-deliveries/")
      .then((res) => setDeliveries(res.data))
      .catch((err) => console.log(err));
  };

  const fetchDrivers = () => {
    axios
      .get(baseUrl + "drivers/")
      .then((res) => setDrivers(res.data))
      .catch((err) => console.log(err));
  };

  useEffect(() => {
    fetchDeliveries();
    fetchDrivers();
  }, []);

  const assignDriver = (deliveryId) => {
    const driverId = selectedDriver[deliveryId];
    if (!driverId) return Swal.fire("Select a driver first");

    axios
      .post(baseUrl + "assign-driver/", { delivery_id: deliveryId, driver_id: driverId })
      .then((res) => {
        Swal.fire("Driver Assigned!", "", "success");
        fetchDeliveries();
      })
      .catch((err) => {
        console.error(err);
        Swal.fire("Error", "Failed to assign driver", "error");
      });
  };

  const autoAssignDriver = (deliveryId, lat, lng) => {
    axios
      .post(baseUrl + "auto-assign-driver/", { order_item_id: deliveryId, delivery_lat: lat, delivery_lng: lng })
      .then((res) => {
        Swal.fire("Driver Auto-Assigned!", "", "success");
        fetchDeliveries();
      })
      .catch((err) => {
        console.error(err);
        Swal.fire("Error", "Failed to auto-assign driver", "error");
      });
  };

  const columns = [
    { field: "id", headerName: "ID", width: 70 },
    { field: "order_item_detail", headerName: "Product", width: 180 },
    {
      field: "driver_detail",
      headerName: "Driver",
      width: 150,
      renderCell: ({ row }) => (
        <span>
          {row.driver_detail?.username || "Not Assigned"}
        </span>
      ),
    },
{
      field: "phone",
      headerName: "Driver Number",
      width: 100,
      renderCell: ({ row }) => (
        <span>
          {row.driver_detail?.phone || "Not Assigned"}
        </span>
      ),
    },
    {
      field: "vehicle_number",
      headerName: "Driver Vehicle",
      width: 150,
      renderCell: ({ row }) => (
        <span>
          {row.driver_detail?.vehicle_number || "Not Assigned"}
        </span>
      ),
    },
    {
      field: "vehicle_type",
      headerName: "Vehicle Type",
      width: 150,
      renderCell: ({ row }) => (
        <span>
          {row.driver_detail?.vehicle_type || "Not Assigned"}
        </span>
      ),
    },
    { field: "status", headerName: "Status", width: 120 },
    {
      field: "assign",
      headerName: "Assign Driver",
      width: 300,
      renderCell: (params) => (
        <div className="d-flex gap-1">
          <select
            className="form-select form-select-sm"
            value={selectedDriver[params.row.id] || ""}
            onChange={(e) =>
              setSelectedDriver({ ...selectedDriver, [params.row.id]: e.target.value })
            }
          >
            <option value="">Select Driver</option>
            {drivers.map((d) => (
              <option key={d.id} value={d.id}>
                {d.username} ({d.vehicle_number})

              </option>
            ))}
          </select>

          <button
            className="btn btn-success btn-sm"
            onClick={() =>
              autoAssignDriver(
  params.row.order_item,
  params.row.current_lat,
  params.row.current_lng
)

            }
          >
            Auto
          </button>
        </div>
      ),
    },
  ];

  return (
    <div className="container mt-4">
      <h3>Seller Deliveries</h3>
      <div style={{ height: "600px", width: "100%" }}>
        <DataGrid
         sx={{
              boxShadow: 4,
              border: 4,
              borderColor: 'primary.light',
              '& .MuiDataGrid-cell:hover': {
                color: 'primary.main',
              },
            }}

          rows={deliveries}
          columns={columns}
          autoHeight
          pageSize={10}
          components={{ Toolbar: GridToolbar }}
        />
      </div>
    </div>
  );
}

export default SellerDeliveries;
